export { default } from './AccessDenied'
